// extracted by mini-css-extract-plugin
export var cardHeader = "_hs-0";
export var reorderHandle = "_hs-3";
export var titleArea = "_hs-1";
export var titleAreaWithHandle = "_hs-2";